<p-toast></p-toast>
<div class="card no-margin">

    <p-table #dt1 [value]="termination" dataKey="edit_id" styleClass="p-datatable-customers" [rows]="10"
        [paginator]="true" [scrollable]="true" [showCurrentPageReport]="true" [loading]="this.loading"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10,25,50]" sortMode="multiple" [globalFilterFields]="[ 
        'sr_no',
        'name',
        'specialty_name',
        'country.country_name',
        'state_name',
        'role',
        'terminated_date',
        'additional_comments']" [scrollable]="true">
        <ng-template pTemplate="caption">
            <div class="table-header">
                <span class="p-input-icon-left">

                   
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="sr_no" style="width: 100px;"><b>Sr No</b>
                    <p-sortIcon field="'sr_no'"></p-sortIcon>
                </th>
                <th pSortableColumn="name"><b>Name </b>
                    <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="specialty_name"><b>Speciality</b>
                    <p-sortIcon field="specialty_name"></p-sortIcon>
                </th>
                <th pSortableColumn="country_name"><b>Country</b>
                    <p-sortIcon field="country_name"></p-sortIcon>
                </th>
                <th pSortableColumn="state_name"><b>State</b>
                    <p-sortIcon field="state_name"></p-sortIcon>
                </th>
                <th pSortableColumn="role"><b>Role</b>
                    <p-sortIcon field="role"></p-sortIcon>
                </th>
                <th pSortableColumn="status"><b>Status</b>
                    <p-sortIcon field="status"></p-sortIcon>
                </th>
                <th pSortableColumn="terminated_date"><b>Terminated Date</b>
                    <p-sortIcon field="terminated_date"></p-sortIcon>
                </th>
                <th pSortableColumn="comments"><b>Comments</b>
                    <p-sortIcon field="comments"></p-sortIcon>
                </th>
                <th pSortableColumn="edit" style="width: 100px;"></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-doctor>
            <tr [pSelectableRow]="doctor">
                <td style="width: 100px;">
                    {{doctor.sr_no}}
                </td>
                <td>

                    <span>{{doctor.name}}</span>
                </td>
                <td>

                    <span>{{doctor.specialty_name}}</span>
                </td>
                <td>

                    <span>{{doctor.country_name}}</span>
                </td>
                <td>

                    <span>{{doctor.state_name}}</span>
                </td>
                <td>

                    <span>{{doctor.role}}</span>
                </td>
                <td>

                    {{doctor.is_active ? 'Active' : 'Inactive'}}
                </td>

                <td>
                    <span>{{doctor.terminated_date==null?'Not Terminated':(doctor.terminated_date | date:'medium')}}</span>
                </td>
                <td>
                    <span>{{doctor.additional_comments == null || doctor.additional_comments == "" ? "N/A" : doctor.additional_comments }}</span>
                </td>
                <td style="width: 100px;">

                    <a class="show_click" (click)="edit(doctor)"><span style="color:blue;">Edit</span></a>
                </td>


            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="9" style="text-align:center;">No Data found.</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
        </ng-template>
        <ng-template pTemplate="paginatorright">
        </ng-template>
    </p-table>
</div>

<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="this.table_response.success!=null && this.table_response.success==false">
    <p *ngIf="this.table_response.error!=null">{{this.table_response.error.message}}</p>
    <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
        <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
        <p>{{this.table_serverError?.message}}</p>
    </div>

</div>





<div *ngIf="updateDialog">
    <p-dialog header="Update Status" [(visible)]="updateDialog" [responsive]="true" (onHide)="Cancel()"
        showEffect="fade" [modal]="true">
        <form #terminationform="ngForm" (ngSubmit)="Submit()">
            <div class="ui-grid ui-grid-responsive ui-fluid">


                <div>

                    <div class="ui-g">
                        <div class="ui-g-12 ui-md-4" style="width:40%">
                            <label for="Is this Speciality Active"> <b>Is The Status Active:</b></label>
                        </div>
                        <div class="ui-g-12 ui-md-4" style="width:30%">
                            <p-radioButton name="is_active" label="Yes" [value]="true" #is_active="ngModel"
                                [(ngModel)]="Doctor.is_active" required></p-radioButton>
                        </div>
                        <div class="ui-g-12 ui-md-4" style="width:30%">
                            <p-radioButton name="is_active" label="No" [value]="false" #is_active="ngModel"
                                [(ngModel)]="Doctor.is_active" required></p-radioButton>
                        </div>

                    </div>

                    <div class="ui-g">
                        <div class="ui-g-12 ui-md-4" style="width:40%">
                            <label> <b>Comments:</b></label>
                        </div>
                        <div class="ui-g-12 ui-md-4" style="width:60%">
                            <textarea pInputTextarea [autoResize]="true" [rows]="5" [cols]="60" maxlength="1000"
                                [pKeyFilter]="textarea" placeholder="Enter Comments" name="additional_comments"
                                #additional_comments="ngModel" [(ngModel)]="Doctor.additional_comments"
                                required></textarea>
                            <div *ngIf="additional_comments.invalid && (additional_comments.dirty || additional_comments.touched)"
                                class="alert alert-danger">
                                <div *ngIf="additional_comments.errors.required" class="invalid">
                                    Explaining why there is a status change, is mandatory.
                                </div>
                            </div>
                            <div *ngIf="Doctor.additional_comments?.length>999" class="invalid alert alert-danger">
                                A maximum of only 1000 characters are allowed.
                            </div>
                        </div>
                        <div class="ui-g-12" style="float: left;">
                            <p [style.color]="Doctor.additional_comments?.length-999>0?'red':'green'"
                                style="float: right;">
                                {{(1001-Doctor.additional_comments?.length)<0?0:1000-Doctor.additional_comments?.length}}
                                of 1000 left</p>

                        </div>
                    </div>
                </div>

            </div>
            <div class="ui-g-12">
                <p-fieldset [style]="{'width':'100%','text-align':'justify'}" styleClass="text-gray-underline">
                    <p-header><b>Note</b><span>*</span></p-header>
                    <p> <b>Yes:</b>The doctor is available with eGlobalDoctors.</p><br>
                    <p> <b>No:</b>The doctor is no more available with eGlobalDoctors.</p>

                </p-fieldset>
            </div>

            <div class="row container justify-content-center text-center alert alert-danger"
                *ngIf="response.success!=null && response.success==false">
                <p *ngIf="response.error!=null">{{response.error.message}}</p>
                <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                    <p *ngFor="let message of serverError?.message">{{message}}</p>
                </div>
                <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                    <p>{{serverError?.message}}</p>
                </div>

            </div>
            <p-footer>
                <!-- <div class="ui-dialog-buttonpane ui-helper-clearfix">
                <br><br> -->
                <p-progressSpinner *ngIf="this.posting==true"
                    [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle','float':'right'}"
                    strokeWidth="6">
                </p-progressSpinner>
                <button type="submit" pButton
                    [disabled]="posting==true || terminationform.valid==false || Doctor.additional_comments?.length==0 || Doctor.additional_comments?.length>999"
                    label="Update" style="margin-right: 20px;float: right;"></button>

                <button type="button" pButton (click)="Cancel()" [disabled]="posting==true" label="Cancel"
                    style="margin-right: 5px;float: right;"></button>
                <!-- </div> -->
            </p-footer>
        </form>
    </p-dialog>
</div>
